import { useSubscription } from "./useSubscription";
import type { Subscription, SubscriptionStatus } from "../types";

export interface SubscriptionGate {
  isLoading: boolean;
  /** Full access — active paid subscription or an ongoing trial. */
  isActive: boolean;
  isTrialing: boolean;
  /** Payment failed but Stripe is still retrying — warn, don't block. */
  isPastDue: boolean;
  /** No usable subscription — canceled, unpaid, or never started. */
  isBlocked: boolean;
  status: SubscriptionStatus | null;
  subscription: Subscription | null;
}

/**
 * Derives billing access flags from the org's subscription row. Phase 1 uses
 * these for a banner + CTA; hard route gating can layer on top later.
 */
export function useSubscriptionGate(): SubscriptionGate {
  const { data, isLoading } = useSubscription();
  const status = data?.status ?? null;

  const isTrialing = status === "trialing";
  const isActive = status === "active" || isTrialing;
  const isPastDue = status === "past_due";
  const isBlocked = !isLoading && !isActive && !isPastDue;

  return {
    isLoading,
    isActive,
    isTrialing,
    isPastDue,
    isBlocked,
    status,
    subscription: data ?? null,
  };
}
